export default __webpack_public_path__ + "static/media/businessman-handshaking-businesswoman-showing-respect-closeup-view-of-hands-shaking.1fa764a0.jpg";